import React from 'react';
import { useTranslation } from 'react-i18next';
import { PAYMENT_LABELS } from '../../utils/paymentLabels';

/** Плитки способов оплаты для РМК */
export default function PaymentMethodTiles({ types, activeTypes, onToggle }) {
    const { t } = useTranslation('cashier');
    return (
        <div className="pos-pay-tiles" role="group" aria-label={t('cashier:paymentMethodsAria')}>
            {types.map(code => {
                const meta = PAYMENT_LABELS[code] || { label: code, icon: '💳' };
                const active = activeTypes.includes(code);
                return (
                    <button
                        key={code}
                        type="button"
                        className={`pos-pay-tile${active ? ' pos-pay-tile--active' : ''}`}
                        onClick={() => onToggle(code)}
                        aria-pressed={active}
                    >
                        <span className="pos-pay-tile__icon" aria-hidden>{meta.icon}</span>
                        <span className="pos-pay-tile__label">{meta.label}</span>
                    </button>
                );
            })}
        </div>
    );
}
